import { render, staticRenderFns } from "./AdminContact.vue?vue&type=template&id=c99751da&scoped=true&"
import script from "./AdminContact.vue?vue&type=script&lang=js&"
export * from "./AdminContact.vue?vue&type=script&lang=js&"
import style0 from "./AdminContact.vue?vue&type=style&index=0&id=c99751da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99751da",
  null
  
)

export default component.exports